import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";
import { CarrierSolicitudeResponseDto, ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";


export class GetCarriersRequestsCommand extends IRequestCommand<
  IGetCarriersRequestsResponse,
  ErrorDetails,
  IGetCarriersRequestsCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carrierAccounts/solicitude/paginated?page={page}&size={size}&column={column}&sort={sort}&find={find}';
  public override setParameters(parameters: IGetCarriersRequestsCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{find}',
      parameters.find.toString()
    );
  }
}

export interface IGetCarriersRequestsCommandParameters
  extends ICommandParameters {
  // carrierEmail?: string;
  page?: number;
  size?: number;
  column?: string;
  sort?: string;
  find: string;
}

export interface IGetCarriersRequestsResponse
  extends CarrierSolicitudeResponseDto,
    ICommandResponse {
  country?: String;
  countryChecked?: Boolean;
  tributeNumber?: String;
  tributeNumberChecked?: Boolean;
  companyName?: String;
  companyNameChecked?: Boolean;
  userName?: String;
  userNameChecked?: Boolean;
  password?: String;
  bankName?: String;
  bankNameChecked?: Boolean;
  bankUniqueNumber?: String;
  bankUniqueChecked?: Boolean;
  email?: String;
  emailChecked?: Boolean;
  commercialLicense?: String;
  commercialLicenseChecked?: Boolean;
  tributeCondition?: String;
  tributeConditionChecked?: Boolean;
  imageLogo?: String;
  imageLogoChecked?: Boolean;
}
